module.exports = __webpack_public_path__ + "static/media/ic-car-grey.57cf0055.svg";